import type { VideoComparison, VideoComparisonSummary } from "./video-latency-control";

/** CSV includes incomplete runs and empty values, so missing measurements never become zero. */
export function videoComparisonCsv(
  camera: string,
  slot: number,
  comparison: VideoComparison
): string {
  const fields: (keyof VideoComparisonSummary)[] = [
    "samples",
    "measuredSeconds",
    "jitterMeanMs",
    "jitterP95Ms",
    "decodeMeanMs",
    "fpsMean",
    "droppedFrames",
    "noFramesSeconds",
  ];
  const escape = (value: unknown) => `"${String(value ?? "").replace(/"/g, '""')}"`;
  const header = [
    "camera",
    "slot",
    "startedAtUtc",
    "status",
    "reason",
    "mode",
    "warmupSeconds",
    "sampleIntervalSeconds",
    ...fields,
  ];
  const records = (["normal", "minimum"] as const).map((mode) => [
    camera,
    slot,
    comparison.startedAtIso,
    comparison.status,
    comparison.reason,
    mode,
    5,
    1,
    ...fields.map((key) => comparison[mode][key]),
  ]);
  return [header, ...records].map((row) => row.map(escape).join(",")).join("\r\n") + "\r\n";
}
